/**
 * Page « Résultat DPE » — vue synthèse immersive (Apple Liquid Glass).
 *
 * Plein écran (sans le Layout standard) : le design porte sa propre identité
 * et un lien « Retour » vers le logement. Données via getReportData (même
 * query que <ReportView>, donc cache partagé et invalidée au recalcul).
 */
import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "react-router-dom";
import { getReportData } from "@/api/dpe";
import { DpeResultScreen } from "@/components/dpe/DpeResultScreen";

export default function LogementResultatPage() {
  const { id = "" } = useParams<{ id: string }>();
  const { data, isLoading, error } = useQuery({
    queryKey: ["report-data", id],
    queryFn: () => getReportData(id),
    enabled: !!id,
  });

  if (isLoading) {
    return (
      <div className="dpe-lg">
        <div className="bg" aria-hidden="true" />
        <div className="state">Chargement de votre estimation…</div>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="dpe-lg">
        <div className="bg" aria-hidden="true" />
        <div className="state">
          <p>Estimation indisponible — le calcul n'a peut-être pas encore été lancé.</p>
          <p style={{ marginTop: 16 }}>
            <Link to={`/logements/${id}/dpe`} style={{ color: "#1e8e4a", fontWeight: 600 }}>
              ← Aller à la saisie
            </Link>
          </p>
        </div>
      </div>
    );
  }

  return <DpeResultScreen data={data} logementId={id} />;
}
